import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  headerClass,
  whatInsideHeight,
} from '@/components/Subscription/PlanTable';

interface Props {
  title?: string;
  className?: string;
  classes?: {
    childDivClass?: string;
    pClass?: string;
  };
  style?: React.CSSProperties;
}

const H1Cell: FC<Props> = ({ title, className, classes, style }) => {
  return (
    <div
      style={{ height: whatInsideHeight, ...style }}
      className={twMerge(
        `

            `,
        className,
      )}
    >
      <div
        className={twMerge(
          'w-full h-full flex items-center justify-start xl:px-4 px-0',
          classes?.childDivClass,
        )}
      >
        <p className={twMerge(`${headerClass}`, classes?.pClass)}>{title}</p>
      </div>
    </div>
  );
};

export default H1Cell;
